import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../image/eco_line.png';
var _hoisted_1 = {
  class: "big_box"
};
var _hoisted_2 = {
  class: "container"
};

var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"eco_title\"></div><div class=\"new_eco_intro\"> Tenacia is a commercial-stage biopharmaceutical company dedicated to developing life-changing therapeutics for patients with underserved neurological disorders. We employ a hybrid corporate development model that combines organic growth through enhanced in-house R&amp;D capabilities, with strategic partnership with MNCs, biotechs and academic institutions. This hybrid approach enables us to efficiently transform neuroscience and accelerate innovation. </div><div class=\"new_eco_intro\"> Equipped with full capabilities spanning early science translation, clinical development, regulatory affairs and commercialization, and a proven track record of swift and high-quality execution in drug development in China, we aspire to be the partner of choice for neuroscience in China and actively seek additional partnerships. We are especially interested in establishing mutually beneficial, strategic collaborations that can fully leverage each party&#39;s expertise and maximize the value of innovation than they would otherwise. </div><div class=\"eco_intro new_eco_intro\"> Together with our partners, we thrive to deliver innovative, differentiated medicines that transform patients&#39; lives in the most effective and efficient way. </div><div class=\"new_eco_title\"> Selected Partners </div>", 5);

var _hoisted_8 = {
  class: "eco_flex"
};
var _hoisted_9 = {
  class: "eco_left_img col-lg-4 col-md-4 col-sm-12 col-xs-12"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "eco_right_contet col-lg-8 col-md-8 col-sm-12 col-xs-12"
};
var _hoisted_12 = {
  class: "eco_r_t"
};
var _hoisted_13 = {
  key: 0
};
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = {
  class: "eco_r_link"
};
var _hoisted_16 = ["onClick"];

var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "eco_close"
}, null, -1);

var _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "eco_line"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_collapse, {
    accordion: false,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partnerList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "eco_content_box",
          key: index
        }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: item.imageUrl,
          class: "eco_l_img"
        }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(item.companyName) + " ", 1), item.aliasName ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(item.aliasName) + ")", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "eco_r_c",
          innerHTML: item.description
        }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, [_createTextVNode(" For more information " + _toDisplayString(item.companyName == 'Marinus Pharmaceuticals' ? 'about Marinus' : '') + " " + _toDisplayString(item.companyName == 'Praxis Precision Medicines' ? 'about Praxis' : '') + " " + _toDisplayString(item.companyName == 'Asia Pacific Medical Group' ? 'about APMG' : '') + " " + _toDisplayString(item.companyName == 'Rapport Therapeutics' ? 'about Rapport' : '') + " " + _toDisplayString(item.companyName == 'Dianthus Therapeutics' ? 'about Dianthus' : '') + " " + _toDisplayString(item.companyName == 'Immedica' ? 'about Immedica' : '') + " , please visit：", 1), _createElementVNode("a", {
          class: "eco_link",
          onClick: function onClick($event) {
            return $setup.jumpWeb(item.websiteLink);
          }
        }, _toDisplayString(item.websiteLink), 9, _hoisted_16)]), _hoisted_17])])]), _hoisted_18]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])]);
}